import { gql } from "@apollo/client";

export default gql`
  fragment RelatedAssessmentSubmission on AssessmentSubmissionNode {
    type
    status
    deliveryId
    completeCount
    pendingCount
    users {
      id
      name
      avatar
    }
    template {
      id
      hasSelfAssessment
      isOnlySelfAssessment
      assessmentType
      anonymity
      delivery
      assessments(targetId: $targetId) {
        edges {
          node {
            id
            target {
              id
            }
            responder {
              id
            }
          }
        }
      }
    }
  }
  query getReviewSubmissions($complianceProgramId: Int!, $targetId: Int!) {
    complianceProgram(pk: $complianceProgramId) {
      id
      assessmentSubmissions(targetId: $targetId) {
        ...RelatedAssessmentSubmission
      }
    }
  }
`;
